import useTranslations from '@/core/hooks/use-translations';
import Link from '@/ui/components/Link/Link';
import Typography from '@/ui/components/Typography/Typography';
import VectorGraphic from '@/ui/components/VectorGraphic/VectorGraphic';
import { useGA4 } from '@/ui/context/ga4';

import $ from './AccountLink.module.scss';

type AccountLinkProps = {
  isMobile?: boolean;
  href?: string;
};

const AccountLink = ({ isMobile = false, href = '/account' }: AccountLinkProps) => {
  const t = useTranslations();
  const { trackMenuNavigation } = useGA4();

  return (
    <Link
      href={href}
      ariaLabel={t('web_general_header_goToAccount')}
      className={$.wrapper}
      onClick={() =>
        trackMenuNavigation({
          menu: 'header',
          menu_path: href,
          menu_text: 'Go to account',
          menu_click: 'picture',
        })
      }
    >
      {isMobile ? (
        <Typography variant="bodyLarge" className={$.text}>
          {t('web_general_header_myMindOasis')}
        </Typography>
      ) : (
        <VectorGraphic name="icon-light-circle-user" className={$.image} />
      )}
    </Link>
  );
};

export default AccountLink;
